<template>
  <div>
     <b-card title="پیش ثبت نام درگاه بین الملل" sub-title="راهنما:">
        
    <b-card-text class="guide">
     <p>جهت نمایش منوی درگاه های بین الملل ،ابتدا درخواست پیش ثبت نام را ثبت نمایید.سپس از منوی ایجاد شده در پنل کاربری خود،اقدام به ثبت درگاه دلاری نمایید.</p>
  
    </b-card-text>
    
       
      </b-card>
    <b-card>
      <b-alert :show="errors.length > 0" variant="danger">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form class="form" @submit.stop.prevent="submitTicket">
        <div>
          <b-row>
            <div class="col-md-6">
              <b-form-group
                id="input-group-1"
                label="عنوان تیکت *: "
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  required
                  v-model="Ticket.subject"
                  placeholder="عنوان تیکت "
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="وبسایت:" >
              <b-form-input aria-describedby="input-1-live-feedback"  v-model="$v.Ticket.website.$model"> </b-form-input>
              <small v-if="!show" class="text-danger pb-0 mb-0"
              >*وبسایت اجباری می باشد</small
            >
            <small v-if="!showValidDomain" class="text-danger pb-0 mb-0"
              >*مجاز به استفاده از دامنه ir و xyz نمی باشید.</small
            >
            </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                id="input-group-3"
                label="دپارتمان: "
                label-for="input-3"
              >
                <b-form-select
                  id="input-3"
                  v-model="Ticket.department_id"
                  :options="departments"
                ></b-form-select>
              </b-form-group>
            </div>
          </b-row>
          <b-form-group
            id="input-group-4"
            label="متن تیکت: "
            label-for="input-4"
          >
            <b-form-textarea
              id="input-4"
              v-model="Ticket.text"
              placeholder="متن تیکت را اینجا تایپ کنید"
              rows="8"
              :disabled="true"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="row">
          <div
            class="col-md-3 mt-3"
            v-for="(x, index) in Ticket.files"
            v-bind:key="x.file_id"
          >
            <!-- <b-img :src="'https://api.shepa.com/api/file/' + x.file_id" fluid></b-img> -->
            <b-button class="mr-5" @click="delete_attachment(index)" size="sm">
              <b-icon icon="trash"></b-icon>
            </b-button>
            <a
              target="_blank"
              :href="'https://api.shepa.com/api/file/' + x.file_id"
              >پیوست شماره {{ index + 1 }}</a
            >
          </div>
        </div>
       
        <b-row class="mt-3">
          <b-col>
            <b-button
              class="mr-3"
              variant="danger"
              @click="$router.push('tickets')"
              >بازگشت</b-button
            >
            <b-button class="mr-3" variant="success" @click="submitTicket"
             :class="
        'ml-3 ' + (isBusyAddTicket ? 'spinner spinner-light spinner-right' : '')
      "
              >ثبت درخواست</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "AddTicketGatewayInternational",
  mixins: [validationMixin],
  components: {
    // fileUploader,
  },
  data: function () {
    return {
      show:true,
      showValidDomain:true,
      isBusyAddTicket:false,
      errors: [],
      priorities: [],
      departments: [],
      ticket_subject: null,
      ticket_content: null,
      ticket_department: null,
      ticket_priority: 6,
      file: "",
      Ticket: {
        subject: "پیش ثبت نام درگاه های دلاری",
        department_id: 11,
        mdid2_periority: 8,
        text: `اینجانب ${JSON.parse( localStorage.getItem('User')).name} ضمن تکمیل روند ثبت نام خود در وبسایت شپا متقاضی دریافت درگاههای بین المللی برای وبسایت به آدرس ........ می باشم.`,
        mdid1_status: 1,
        files: [],
        website:"",
      },
    };
  },
   validations: {
    Ticket: {
      website: {
        required, 
      },
      
    },
   },
  watch:{
    'Ticket.website'(newVal,oldVal){
      newVal.endsWith('.ir') || newVal.endsWith('.xyz') ? this.showValidDomain=false : this.showValidDomain=true;
       this.show=newVal!=""? true: false;
      this.Ticket.text=`اینجانب ${JSON.parse( localStorage.getItem('User')).name} ضمن تکمیل روند ثبت نام خود در وبسایت شپا متقاضی دریافت درگاههای بین المللی برای وبسایت به آدرس ${newVal.length!=0 ? newVal : '......'} می باشم.`
    }
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "درخواست ها", route: "/tickets" },
      { title: "ثبت درخواست" },
    ]);
    httpHelper.setAuth();
    httpHelper
      .getData("/metadata?metadata_group_id=2")
      .then((response) => {
        this.priorities = response.result.map((item) => {
          return { value: item.id, text: item.title };
        });
      })
      .catch((error) => {})
      .finally(() => {});

    httpHelper
      .getData("/departments")
      .then((response) => {
        this.departments = response.result
          .filter((item) => {
            return item.id == 11;
          })
          .map((item) => {
            return { value: item.id, text: item.name };
          });
      })
      .catch((error) => {})
      .finally(() => {});
  },
  methods: {
    submitTicket: function () {
      if (this.$v.Ticket.website.$model==="") {
          this.show=false;
        return;
      }
      if(this.$v.Ticket.website.$model.endsWith('.ir') || this.$v.Ticket.website.$model.endsWith('.xyz')){
        this.showValidDomain=false;
        return;
      }
      this.showValidDomain=true;
      this.show=true;
      this.isBusyAddTicket=true;
      httpHelper
        .postData("tickets", this.Ticket)
        .then((response) => {
          this.isBusyAddTicket=false;
          if (response.success) { 
            this.$router.push( { path:"/ticketDetails/" + response.result , query : { ticket:'new' } } );
          } else {
            for (const key in response.error) {
              if (response.error.hasOwnProperty(key)) {
                const element = response.error[key];
                element.forEach((er) => {
                  this.errors.push(er);
                });
              }
            }
          }
        })
        .catch((error) => {})
        .finally(() => {});
    },
    delete_attachment(index) {
      this.Ticket.files.splice(index, 1);
    },
  },
  mounted() {},
};
</script>